import { render, staticRenderFns } from "./dr-content-item.vue?vue&type=template&id=137ba808&"
import script from "./dr-content-item.vue?vue&type=script&lang=js&"
export * from "./dr-content-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports